export const STATUS_PENDENTE = 0;
export const STATUS_FALHA = 99;
export const STATUS_SUCESSO = 100;

export const Status = {
  [STATUS_PENDENTE]: {title: 'Pendente', class: 'text-info'},
  [STATUS_FALHA]: {title: 'Falha', class: 'text-negative'},
  [STATUS_SUCESSO]: {title: 'Migrado', class: 'text-positive'}
}
